import { InputPadrao, InputDatePicker, InputTelefone, InputSummernote } from '../../../../components/Inputs'
import { InputAgendaPaciente, InputAtividadeEconomica, InputBeneficiario, InputBeneficiarioTitular, InputEmpresaParceira, InputEstado, InputEstadoCivil, InputGrauDependencia, InputGrauInstrucao, InputMunicipio, InputOperadoraSaude, InputPais, InputPessoaJuridicaTipo, InputRaca, InputSexo } from '../../../../components/InputsAutoComplete'
import React, { useState, useEffect, useRef, useCallback } from 'react'
import Yup, { validaCNPJ, validaCPF, validaData } from '../../../../util/Validacoes'
import { HeaderCadastro } from '../../../../components/Headers'
import { mostrarToast } from '../../../../components/Toasts'
import { Formik, Form } from 'formik'
import { BotaoPadrao } from '../../../../components/Botoes'
import { ajustarDadosTelefone, buscarCep, mensagens } from '../../../../util/Utilitarios'
import { useParams } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { salvar, get, consultar, visualizar, acoesAgenda } from '../../../../util/AcessoApi'
import '../../../../assets/css/icones/iconsmind/style.css';
import Atalho from '../../../../util/Atalho'
import { ACOES, AGENDA_STATUS, MODULO } from '../../../../util/Enums'
import InputArquivoS3 from '../../../../components/InputArquivoS3'
import moment from 'moment'
import { downloadArquivoS3 } from '../../../../util/FuncoesComuns'
import { ModalDuasOpcoes, ModalPadraoCadastro } from '../../../../components/Modais'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { getUsuario } from '../../../../util/Configuracoes'

const CadastroProntuario = (props) => {
    let { id } = useParams()
    const history = useHistory();
    const pacienteURL = history.location?.state?.paciente
    const locationAgendaId = history.location?.state?.agenda
    const locationAgendaStatus = history.location?.state?.status_agenda
    const [salvarENovo, setSalvarENovo] = useState(false)
    const [salvando, setSalvando] = useState(false)
    const [dataArquivos, setDataArquivos] = useState(null)
    const [valoresIniciais, setValoresIniciais] = useState({})
    const [limparArquivos, setLimparArquivos] = useState(false)
    const [showModalAtendimento, setShowModalAtendimento] = useState(false)
    const [showModalFinalizarAtendimento, setShowModalFinalizarAtendimento] = useState(false)
    const refArquivo = useRef(null)
    const [showModalDetalhes, setShowModalDetalhes] = useState(false)
    const [paciente, setPaciente] = useState(null)
    const [agendaId, setAgendaId] = useState()


    const [validacao] = useState(Yup.object({
        paciente: Yup.string().required().nullable().trim().required(),
        resumo: Yup.string().required().nullable().trim().required(),
    }))
    const manter = ['paciente']

    const Submit = (values, propsFormik) => {
        setSalvando(true)
        values.arquivo = dataArquivos
        salvar(
            { ...values },
            '/atendimento/prontuario',
            obj => {
                setLimparArquivos(true)
                mostrarToast('sucesso', mensagens.sucesso)
                propsFormik.resetForm({})
                manter.forEach(x => propsFormik.setFieldValue(x, values[x]))
                props.atualizarHistorico(values?.paciente?.value);
                setShowModalFinalizarAtendimento(true)
                setSalvando(false)
                setLimparArquivos(false)
            },
            () => setSalvando(false))
    }

    useEffect(_ => {
        if (pacienteURL)
            Promise.resolve(get(`/atendimento/beneficiariocombo/${pacienteURL}`)).then(obj => {
                obj[0].agen_id = locationAgendaId
                setValoresIniciais({ paciente: obj[0] })
                onChangePaciente(obj[0])
                setDataArquivos([])
            })
        else {
            setDataArquivos([])
            setValoresIniciais({
                paciente: "",
                cooperado: "",
                resumo: ''
            })
        }
    }, [pacienteURL])

    useEffect(() => {
        if (locationAgendaId) {
            setAgendaId(locationAgendaId)
            if (locationAgendaStatus != 3)
                setShowModalAtendimento(true);
        }
    }, [locationAgendaId])

    useEffect(() => {

        if (valoresIniciais?.paciente?.label)
            setPaciente(valoresIniciais.paciente)

    }, [valoresIniciais])

    const onChangePaciente = (option) => {
        setAgendaId(option.agen_id)
        if (locationAgendaStatus != 3)
            setShowModalAtendimento(true);
        props.atualizarHistorico(option?.value);
        setPaciente(option)
    };

    return (<>
        <Formik
            initialValues={valoresIniciais}
            validationSchema={validacao}
            enableReinitialize={true}
            onSubmit={(values, propsFormik) => Submit(values, propsFormik)}>
            {propsFormik => {
                return (<Form>
                    <div className={props.modal && props.modal || 'card mb-20'}>
                        <div className={props.modal || 'card-body'}>
                            <div className='row'>
                                <InputPadrao label='Id' name='id' type='hidden' placeholder='Id' />

                                <InputAgendaPaciente
                                    obrigatorio={true}
                                    label="Paciente"
                                    name="paciente"
                                    placeholder="Paciente"
                                    propsFormik={propsFormik}
                                    tamanho='col-sm-12 col-md-12 col-lg-6 col-xl-6'
                                    onChangeOption={onChangePaciente}
                                    iconeBtn={'icon-Books-2'}
                                    acaoBtn={() => {
                                        setShowModalDetalhes(true)
                                    }}
                                    botaoVisivel={true}
                                />

                                <InputSummernote label="Resumo" placeholder='Resumo' obrigatorio={true} name="resumo" propsFormik={propsFormik} tamanho={"col-12"} config={{ heightMin: 500 }} {...props} />

                                {dataArquivos != null ?
                                    <InputArquivoS3
                                        ref={refArquivo}
                                        name='arquivo'
                                        label='Arquivos'
                                        placeholder='Arquivos'
                                        tamanho='col-12'
                                        diretorioS3='prontuario/DDMMYYYY/'
                                        modulo={MODULO["/atendimento/prontuario"]}
                                        tamanhoMinimo={0}
                                        tamanhoMaximoEmMB={300}
                                        setDataArquivos={setDataArquivos}
                                        dataArquivos={dataArquivos != null ? dataArquivos : []}
                                        setIsSubmit={dataArquivos.length > 0 ? setSalvando : () => { }}
                                        limparCampos={limparArquivos}
                                    /> : <></>}

                                <Atalho formik={propsFormik} salvando={salvando} setSalvareNovo={setSalvarENovo} salvarENovo={true} />
                            </div>
                        </div>
                    </div>
                    <div className='separator mt-40 mb-5'></div>
                    <div className='direita container-botoes mb-3 group-salvar-novo'>
                        <BotaoPadrao texto='Salvar' disabled={salvando} click={_ => setSalvarENovo(true)} idTooltip={'salvarENovo'} />
                    </div>
                    <ModalDetalhes paciente={paciente} showModal={showModalDetalhes} setShowModal={setShowModalDetalhes} />
                </Form>)
            }}
        </Formik>
        <ModalIniciarAtendimento showModal={showModalAtendimento} setShowModal={setShowModalAtendimento} paciente={paciente} id={agendaId} />
        <ModalFinalizarAtendimento showModal={showModalFinalizarAtendimento} setShowModal={setShowModalFinalizarAtendimento} paciente={paciente} id={agendaId} />
    </>
    )
}

const Timeline = React.forwardRef((props, ref) => {
    const [pagina, setPagina] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [timeline, setTimeline] = useState([]);
    const containerRef = useRef(null);
    const usuario = getUsuario()

    const carregarHistorico = useCallback((paciente) => {
        setIsLoading(true)

        if (paciente)
            consultar('/atendimento/prontuariohistorico', val => {
                setTimeline(val)
                setIsLoading(false)
            }, null, { paciente: paciente, id_usuario: usuario.id })
        else {
            setIsLoading(false)
            setTimeline([])
        }
    }, [])

    if (ref) {
        ref.current = {
            carregarHistorico: (paciente) => carregarHistorico(paciente)
        }
    }

    return (<div className={'card mb-20'}>
        <div className={'card-body'}>
            <h3>Histórico</h3>
            <div className={'patient-timeline custom-scrollbar'} ref={containerRef}>
                {isLoading ? (
                    <div className='no-data-timeline'>
                        <span className="spinner-border spinner-border-md" role="status" aria-hidden="true" style={{ opacity: 0.2 }}></span>
                    </div>
                ) : timeline.length > 0 ? (
                    timeline.map((item, index) => (
                        <div className="historico-card">
                            <div className="flex-end mb-2">
                                <span className="span-hora">{item.data_registro}</span>
                            </div>
                            <div class="mt-2 mb-2" dangerouslySetInnerHTML={{ __html: item.resumo.toString() }} />
                            <hr />
                            <div><b>Arquivos:</b></div>
                            <div className="row mr-0 ml-0 mt-1">
                                {item?.arquivo && item?.arquivo.length > 0 ? item?.arquivo?.map(aq => <div className="col-12 mb-1 p-0">
                                    <div className='nome-arquivo row-space-between arquivo'>
                                        <div className='vertical-center'>
                                            <span className="card-text truncate">{aq.nome_arquivo}</span>
                                        </div>
                                        <div>
                                            <button type="button" onClick={() => downloadArquivoS3(aq.s3Key)} className={"btn-download-arquivo"}><span className="icon-Download-fromCloud"></span></button>
                                        </div>
                                    </div>
                                </div>) : <div><span>Não há Arquivos</span></div>}
                            </div>
                            <hr />
                            <div className="flex-end mb-2"><span className="span-nome"><b><i>{item.cooperado}</i></b></span></div>
                        </div>
                    ))
                ) : (
                    <div className='no-data-timeline'>
                        <span className="icon-File-ClipboardFileText" />
                        <p>Não Há Dados</p>
                    </div>
                )}
            </div>
        </div>
    </div>
    )
});

const Cadastro = (props) => {
    const historicoRef = useRef();

    const links = [
        () => <Link to={'/dashboard'}>Dashboard</Link>,
        () => <span>Atendimento</span>,
        () => <Link className='link-active' to={'/atendimento/prontuario/consulta'}>Prontuário</Link>,
    ]
    return (<>
        {<HeaderCadastro titulo={"Prontuário"} link={links} />}
        <div className='row'>
            <div className='col-9'>
                <CadastroProntuario {...props} atualizarHistorico={paciente => historicoRef?.current ?
                    historicoRef?.current?.carregarHistorico(paciente) : () => { }} />

            </div>
            <div className='col-3'>
                <Timeline ref={historicoRef} />
            </div>
        </div>
    </>
    )
}

const ModalDetalhes = (props) => {
    const [itemDetalhes, setItemDetalhes] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const obterPaciente = async () => {
        if (!props.paciente)
            return;

        setIsLoading(true);

        let dados = {}


        await Promise.resolve(get(`/atendimento/detalhespacienteprontuario`, props.paciente)).then(obj => {
            console.log('obj: ', obj);
            dados.paciente = [
                { titulo: 'Código', descricao: obj.id },
                { titulo: 'Nome', descricao: obj.nome },
                { titulo: 'Nome Titular', descricao: obj.beneficiario_titular?.label },
                { titulo: 'Data de Nascimento', descricao: obj.data_nascimento },
                { titulo: 'CPF', descricao: obj.cpf },
                { titulo: 'RG', descricao: obj.rg },
                { titulo: 'CNS', descricao: obj.cns },
                { titulo: 'Plano', descricao: obj.plano },
                { titulo: 'N° Carteira', descricao: obj.numero_carteira },
                { titulo: 'Validade Carteira', descricao: obj.validade_carteira },
                { titulo: 'Email', descricao: obj.email },
                { titulo: 'Data de Registro', descricao: obj.data_registro },
                { titulo: 'Município - UF', descricao: obj.municipio?.label },
                { titulo: 'Logradouro', descricao: obj.logradouro },
                { titulo: 'CEP', descricao: obj.cep },
                { titulo: 'Complemento', descricao: obj.complemento },
                { titulo: 'Número', descricao: obj.numero },
                { titulo: 'Bairro', descricao: obj.bairro }
            ]

            dados.agenda = [
                { titulo: 'Data Agendamento', descricao: obj.agen_data },
                { titulo: 'Hora Inicial', descricao: obj.agen_hora_final },
                { titulo: 'Hora Final', descricao: obj.agen_hora_inicial },
            ]
            setItemDetalhes(dados)
            setIsLoading(false)

        })

    }

    useEffect(() => {
        if (props.showModal)
            obterPaciente()
    }, [props.showModal])

    return <ModalPadraoCadastro titulo={'Detalhes Agenda/Paciente'} showModal={props.showModal} setShowModal={props.setShowModal}>
        {isLoading ?
            <div className='no-data-timeline'>
                <span className="spinner-border spinner-border-md" role="status" aria-hidden="true" style={{ opacity: 0.2 }}></span>
            </div> :
            <>

                <div className='detalhes' style={{ marginBottom: 5 }}>
                    {
                        itemDetalhes && itemDetalhes.agenda && itemDetalhes.agenda.length > 0 ?
                            <div className="modal-header">
                                <h5 className="modal-title"><span>Agenda</span></h5>
                            </div>
                            : <></>
                    }
                    <div>
                        <ul className='lista-modal'>
                            {itemDetalhes?.agenda && itemDetalhes?.agenda?.map((item, idx) => {
                                return (
                                    <>
                                        {idx === 0 ? <></> : <hr />}
                                        <div className='item-detalhes'>
                                            <h6><b>{item.titulo}</b></h6>
                                            <h6>{item.descricao}</h6>
                                        </div>
                                    </>
                                )
                            })}
                        </ul>
                    </div>
                </div>


                <div className='detalhes'>

                    {
                        itemDetalhes && itemDetalhes.paciente && itemDetalhes.paciente.length > 0 ?
                            <div className="modal-header">
                                <h5 className="modal-title"><span>Paciente</span></h5>
                            </div>
                            : <></>
                    }
                    {itemDetalhes?.paciente && itemDetalhes?.paciente?.map((item, idx) => {
                        return (
                            <>
                                {idx === 0 ? <></> : <hr />}
                                <div className='item-detalhes'>
                                    <h6><b>{item.titulo}</b></h6>
                                    <h6>{item.descricao}</h6>
                                </div>
                            </>
                        )
                    })}




                </div >


            </>
        }
    </ModalPadraoCadastro >
}

const ModalIniciarAtendimento = (props) => {
    const [salvando, setSalvando] = useState(false)

    const Submit = () => {
        setSalvando(true)
        let valuesAjustados = {
            id: props.id,
            status: { value: AGENDA_STATUS.EM_ATENDIMENTO }
        }

        acoesAgenda(
            valuesAjustados,
            '/atendimento/agendastatus',
            () => {
                mostrarToast('sucesso', 'Iniciando atendimento');
                setSalvando(false)
                props.setShowModal(false);
            },
            () => setSalvando(false),
            null,
            ACOES.ALTERAR_STATUS_AGENDA,
        )
    }

    return (<ModalDuasOpcoes
        showModal={props.showModal}
        setShowModal={props.setShowModal}
        funcaoOpcao2={() => Submit()}
        funcaoOpcao1={() => props.setShowModal(false)}
        esconderFechar
        mensagem={
            <>
                Deseja iniciar o atendimento para <b>{props?.paciente?.label}</b>?
                <br />
            </>
        }
        textoOpcao1={'Cancelar'}
        classeOpcao1={'btn-sm btn-primary-modal simples'}
        textoOpcao2={'Iniciar Atendimento'}
        salvando={salvando}
    />)
}

const ModalFinalizarAtendimento = (props) => {
    const [salvando, setSalvando] = useState(false)

    const Submit = () => {
        setSalvando(true)
        let valuesAjustados = {
            id: props.id,
            status: { value: AGENDA_STATUS.FINALIZADO }
        }

        acoesAgenda(
            valuesAjustados,
            '/atendimento/agendastatus',
            () => {
                mostrarToast('sucesso', 'Finalizando atendimento');
                setSalvando(false)
                props.setShowModal(false);
            },
            () => setSalvando(false),
            null,
            ACOES.ALTERAR_STATUS_AGENDA,
        )
    }

    return (<ModalDuasOpcoes
        showModal={props.showModal}
        setShowModal={props.setShowModal}
        funcaoOpcao2={() => Submit()}
        funcaoOpcao1={() => props.setShowModal(false)}
        esconderFechar
        mensagem={
            <>
                Deseja finalizar o atendimento para <b>{props?.paciente?.label}</b>?
                <br />
            </>
        }
        textoOpcao1={'Cancelar'}
        classeOpcao1={'btn-sm btn-primary-modal simples'}
        textoOpcao2={'Finalizar Atendimento'}
        salvando={salvando}
    />)
}
export { CadastroProntuario }
export default Cadastro